import Vue from "vue";
import axios from "axios"
import Vuetify from "vuetify/lib/framework";

Vue.use(Vuetify,axios);

export default new Vuetify({});
